import type { CarImage } from "@interfaces/gallery";
import { ImageCard } from "@components/molecules/ImageCard/ImageCard";
import { createImageGroups } from "@helpers/image-grid-helper";
import styles from "./styles.module.scss";

interface MobileGridProps {
  displayedImages: CarImage[];
  handleImageClick: (variantId: string) => void;
  initialVariantsCount: number;
}

export const MobileGrid = ({
  displayedImages,
  handleImageClick,
  initialVariantsCount,
}: MobileGridProps) => {
  const imageGroups = createImageGroups(displayedImages);
  return imageGroups.map((rowImages, chunkIndex) => (
    <div
      key={chunkIndex}
      className={styles["mobile-grid__row"]}
      style={{
        gridTemplateColumns: `repeat(${rowImages.length}, 1fr)`,
      }}
    >
      {rowImages.map((image, idx) => (
        <ImageCard
          key={image.variant_Id}
          image={image}
          onClick={handleImageClick}
          showVariantCount={chunkIndex === 0 && idx === 0}
          variantCount={initialVariantsCount}
          className={styles["mobile-grid__image-card"]}
          priority
        />
      ))}
    </div>
  ));
};
